// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cKvFdOMEgt_BKcUrgUVF {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  padding: 9px 0 7px;
  width: 92px;
}
.cKvFdOMEgt_BKcUrgUVF img,
.cKvFdOMEgt_BKcUrgUVF svg {
  height: 32px;
  width: auto;
  image-rendering: crisp-edges;
}
.cKvFdOMEgt_BKcUrgUVF::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--piliot-green);
  transform-origin: center;
  transform: scaleX(0);
}
.cKvFdOMEgt_BKcUrgUVF[data-is-active='true']::after {
  transform: scaleX(1);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.cKvFdOMEgt_BKcUrgUVF[data-is-active='true'] .bhQWRmiVD0d_MBIVT2GN {
  color: var(--piliot-green);
}
.bhQWRmiVD0d_MBIVT2GN {
  color: #fff;
  font-size: 14px;
  line-height: initial;
  transition: color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 12px 0 9px;
    gap: 3px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 9px 0 7px;
    gap: 3px;
    width: 88px;
  }
  .cKvFdOMEgt_BKcUrgUVF img,
  .cKvFdOMEgt_BKcUrgUVF svg {
    height: 32px;
  }
  .bhQWRmiVD0d_MBIVT2GN {
    font-size: 14px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 9px 0 7px;
    gap: 3px;
    width: 88px;
  }
  .cKvFdOMEgt_BKcUrgUVF img,
  .cKvFdOMEgt_BKcUrgUVF svg {
    height: 32px;
  }
  .bhQWRmiVD0d_MBIVT2GN {
    font-size: 14px;
  }
}
}
}
}
@media (max-width: 374px) and (orientation: portrait) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 8px 0 6px;
    width: 78px;
  }
  .cKvFdOMEgt_BKcUrgUVF img,
  .cKvFdOMEgt_BKcUrgUVF svg {
    height: 28px;
  }
  .bhQWRmiVD0d_MBIVT2GN {
    font-size: 12px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 6px 0 5px;
    gap: 2px;
    width: 88px;
  }
  .cKvFdOMEgt_BKcUrgUVF img,
  .cKvFdOMEgt_BKcUrgUVF svg {
    height: 28px;
  }
  .bhQWRmiVD0d_MBIVT2GN {
    font-size: 13px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .cKvFdOMEgt_BKcUrgUVF {
    padding: 6px 0 5px;
    gap: 2px;
    width: 88px;
  }
  .cKvFdOMEgt_BKcUrgUVF img,
  .cKvFdOMEgt_BKcUrgUVF svg {
    height: 28px;
  }
  .bhQWRmiVD0d_MBIVT2GN {
    font-size: 13px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/IngameNavigation/IngameNavigationItem/IngameNavigationItem.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,uDAAuD;AACzD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,2DAA2D;AAC7D;AACA;EACE;IACE,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;AAAA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAbA;AAAA;AAAA;AAAA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAbA;AAAA;AAAA;AAAA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;;IAEE,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".tab {\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  padding: 9px 0 7px;\n  width: 92px;\n}\n.tab img,\n.tab svg {\n  height: 32px;\n  width: auto;\n  image-rendering: crisp-edges;\n}\n.tab::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: var(--piliot-green);\n  transform-origin: center;\n  transform: scaleX(0);\n}\n.tab[data-is-active='true']::after {\n  transform: scaleX(1);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.tab[data-is-active='true'] .tabLabel {\n  color: var(--piliot-green);\n}\n.tabLabel {\n  color: #fff;\n  font-size: 14px;\n  line-height: initial;\n  transition: color 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n@media (--campaign-mobile) {\n  .tab {\n    padding: 12px 0 9px;\n    gap: 3px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .tab {\n    padding: 9px 0 7px;\n    gap: 3px;\n    width: 88px;\n  }\n  .tab img,\n  .tab svg {\n    height: 32px;\n  }\n  .tabLabel {\n    font-size: 14px;\n  }\n}\n@media (--campaign-mobile-narrow) {\n  .tab {\n    padding: 8px 0 6px;\n    width: 78px;\n  }\n  .tab img,\n  .tab svg {\n    height: 28px;\n  }\n  .tabLabel {\n    font-size: 12px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .tab {\n    padding: 6px 0 5px;\n    gap: 2px;\n    width: 88px;\n  }\n  .tab img,\n  .tab svg {\n    height: 28px;\n  }\n  .tabLabel {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab": `cKvFdOMEgt_BKcUrgUVF`,
	"tabLabel": `bhQWRmiVD0d_MBIVT2GN`
};
export default ___CSS_LOADER_EXPORT___;
